<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="pay-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>
                    <div class="pay-view">
                        <p>花费<b>{{ cost }}</b><em class="icon i-m3b"></em>{{ text }}</p>
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn ok" @click="buy"></div>
                        <!-- <div class="u-btn cancel" @click="closeModal"></div> -->
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style scoped>
.pay-modal{
    position: relative;
    width: 578px;
    height: 332px;
    font-size: 24px;
    color: #6f3615;
    background-image: url(~@/assets/images/bg-extra.png);
}

.title{
    width: 195px;
    height: 28px;
    margin: 15px auto 24px;
    background-image: url(~@/assets/images/title-extra.png);    
}

.pay-view{
    padding: 10px 30px 0;
    line-height: 1.8;
    font-size: 24px;
    color: #3f2a0e;
    text-align: center;
}

.pay-view b{
    color: #fe5a1e;
}

.pay-view .icon{
    display: inline-block;
    width: 19px;
    height: 19px;
    margin: 0 5px;
    background-image: url(~@/assets/images/icon-m3b.png);
    /* vertical-align: sub; */
}

.u-ctrl{
    position: absolute;
    left: 50%;
    bottom: 58px;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateX(-50%);
}

.u-ctrl .u-btn.ok{
    width: 225px;
    height: 60px;
    margin: 48px auto 0;
    background-image: url(~@/assets/images/btn-ok.png);    
}

</style>

<script>
export default {
    data () {
        return {
            visible : false,
            gid : '2',
            giftName : '鸡王福利',
            cost : 599,
            num : 1,
            score : 0,
            text : '开启鸡王奖励通道，开启购买加码奖励资格，并且每周可领取枪王升级宝箱！',
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        //this.$be_busy();
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        buy (){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                this.closeModal();

                return this.$bind_modal();
            }

            this.$axios.post(globalThis.ajax_url_map.buy,{
                giftId : this.gid.toString(),
                num : this.num,
            })
            .then(
                res => {
                    this.uflag_update();
                    
                    this.destroyElement ();
                    this.$success_Modal({text : '购买成功'});

                    //this.$update_userType(10)
                },
                rej => {
                    this.destroyElement ();
                    let type = rej.code == 416 ? 2 : 1;
                    this.$error_Modal({text : rej.message , type : type});
                },
            )

        },
        uflag_update (){
          this.$store.commit("$_setFlag", this.gid);          
        },       
    },    
}
</script>


// WEBPACK FOOTER //
// src/components/ComfirmWarn/comfirmModal.vue